export default __webpack_public_path__ + "static/media/refresh.91424661.svg";